import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RolesGuard} from "./roles.guard";
import {Permission, RoleService} from "./role.service";

@Injectable()
export class RolesTabsGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router, private roleService: RoleService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let permission = this.getTabPermission(route,state);
        if(!permission) {
            permission = this.getNextTabEnable(route);
            if(permission) {
                this._router.navigate([permission.route.replace(':id',route.params['id'])]);
            } else {
                this._router.navigate([RolesGuard.UNAUTHORIZED_PAGE]);
            }
            return false;
        }
        return true;
    }

    private getTabPermission(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Permission {
        return this.getTabPermissions(route).find(permission => {
            const permissionRegex = new RegExp('^' + permission.route.replace('/:id','/[0-9]+')+ '$');
            return permissionRegex.test(state.url);
        });
    }

    private getTabPermissions(route: ActivatedRouteSnapshot): Array<Permission> {
        return  this.roleService.getPermissions().filter(permission => {
            const reg = new RegExp(route.routeConfig.path + '.+');
            return reg.test(permission.route);
        })
    }

    private getNextTabEnable(route: ActivatedRouteSnapshot) {
        return this.getTabPermissions(route).find(permission => {
            const child = route.routeConfig.children.find(child => {
                const reg = new RegExp("/" + child.path + ".*");
                return reg.test(permission.route);
            })
            return !!child;
        })
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const permission = this.roleService.getPermissions().find(permission => {
            const permissionRegex = new RegExp('^' + permission.route.replace('/:id','/[0-9]+')+ '$');
            return permissionRegex.test(state.url);
        });
        if(!permission) {
            this._router.navigate([RolesGuard.UNAUTHORIZED_PAGE]);
            return false;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/roles.tabs.guard.ts